var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBackArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.666,
    height: 12,
    viewBox: "0 0 6.666 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Arrow_left",
    d: "M6,2.01,10.54,6.421a.872.872,0,0,0,1.211,0,.823.823,0,0,0,0-1.18L6.61.243A.874.874,0,0,0,5.427.218L.25,5.238a.821.821,0,0,0,0,1.18.872.872,0,0,0,1.211,0Z",
    transform: "translate(0 12) rotate(-90)",
    fill: "#03c4de"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBackArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/backArrow.1fbcb186cb49978d1950441e24287a87.svg";